<template>
  <div class="detail-container">
    <div class="page-header">
      <div class="header-title">
        <div class="title-mark"></div>
        <span>应付账款明细表</span>
      </div>
      <el-button size="small" icon="el-icon-back" @click="goBack">返回汇总表</el-button>
    </div>

    <div class="scope-tip" v-if="contractId">
      <span>合同：{{ scopeContractLabel }}</span>
    </div>

    <div class="search-area">
      <el-date-picker
        v-model="startDate"
        type="date"
        placeholder="查询时间起"
        aria-label="查询时间起"
        value-format="yyyy-MM-dd"
        clearable
        class="search-input date-picker"
      ></el-date-picker>
      <el-date-picker
        v-model="endDate"
        type="date"
        placeholder="查询时间止"
        aria-label="查询时间止"
        value-format="yyyy-MM-dd"
        clearable
        class="search-input date-picker"
      ></el-date-picker>
      <el-input
        v-model="settlementNumber"
        placeholder="结算单号"
        clearable
        class="search-input"
        style="width: 220px"
      ></el-input>
      <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
      <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
      <el-button v-permission="'statistics:accounts-payable-summary:export'" type="warning" @click="handleExport" icon="el-icon-download" :loading="exportLoading">导出</el-button>
    </div>

    <div class="table-area">
      <el-table
        :data="tableData"
        border
        stripe
        show-summary
        :summary-method="summaryMethod"
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <el-table-column prop="settlementNumber" label="结算单号" min-width="140" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="settlementDate" label="结算日期" width="170" align="center">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.settlementDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="dueDate" label="到期时间" width="170" align="center">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.dueDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="settlementAmount" label="结算金额" width="150" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.settlementAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="paidAmount" label="已付款金额" width="150" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.paidAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="payableBalance" label="应付款金额" width="150" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.payableBalance) }}
          </template>
        </el-table-column>
        <el-table-column prop="duePayableAmount" label="已到期应付款" width="150" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.duePayableAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="duePayableBalance" label="已到期应付款余额" width="160" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.duePayableBalance) }}
          </template>
        </el-table-column>
        <el-table-column prop="overduePayableAmount" label="超期应付款金额" width="150" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.overduePayableAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="overdueDays" label="超期天数" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.overdueDays != null ? scope.row.overdueDays : '0' }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper, sizes, total"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'AccountsPayableSummaryDetail',
  data() {
    return {
      contractId: null,
      scopeContractName: '',
      startDate: '',
      endDate: '',
      settlementNumber: '',
      loading: false,
      exportLoading: false,
      tableData: [],
      detailTotals: null,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    scopeContractLabel() {
      const id = this.contractId
      const name = this.scopeContractName || ''
      if (name && id) return `${name}（ID ${id}）`
      if (id) return `ID ${id}`
      return ''
    }
  },
  created() {
    this.initFromRoute()
    if (!this.contractId) {
      this.$message.warning('缺少合同参数，请从应付账款汇总表点击「明细表」进入')
    } else {
      this.loadData()
    }
  },
  methods: {
    initFromRoute() {
      const q = this.$route.query
      const cid = q.contractId != null ? parseInt(String(q.contractId), 10) : NaN
      this.contractId = Number.isFinite(cid) ? cid : null
      this.scopeContractName = (q.contractName && String(q.contractName)) || ''
      this.startDate = q.startDate || ''
      this.endDate = q.endDate || ''
    },
    goBack() {
      this.$router.push({ name: 'AccountsPayableSummary' })
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleReset() {
      this.startDate = ''
      this.endDate = ''
      this.settlementNumber = ''
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleExport() {
      if (this.startDate && this.endDate && this.startDate > this.endDate) {
        this.$message.warning('查询时间起不能晚于查询时间止')
        return
      }
      if (!this.contractId) {
        this.$message.warning('缺少合同，无法导出')
        return
      }
      this.exportLoading = true
      const params = { contractId: this.contractId }
      if (this.startDate) params.startDate = this.startDate
      if (this.endDate) params.endDate = this.endDate
      const sn = (this.settlementNumber || '').trim()
      if (sn) {
        params.settlementNumber = sn
      }
      api.statistics.exportAccountsPayableSummaryDetail(params)
        .then(response => {
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          const contentDisposition = response.headers['content-disposition']
          let fileName = '应付账款明细表.xlsx'
          if (contentDisposition) {
            const match = contentDisposition.match(/filename\*?=([^;]+)/i)
            if (match) {
              fileName = decodeURIComponent(match[1].replace(/^UTF-8''/, '').trim())
            }
          }
          link.download = fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          this.$message.success('导出成功')
        })
        .catch(err => {
          this.$message.error(err.response?.data?.message || '导出失败')
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    },
    formatAmount(amount) {
      if (amount === undefined || amount === null) return '0.00'
      return Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    formatDateTime(val) {
      if (!val) return ''
      const s = String(val)
      return s.length >= 16 ? s.replace('T', ' ').slice(0, 16) : s.replace('T', ' ')
    },
    summaryMethod() {
      const t = this.detailTotals || {}
      const fmt = k => this.formatAmount(t[k] != null ? t[k] : 0)
      const days = t.overdueDaysSum != null ? String(t.overdueDaysSum) : '0'
      return ['合计', '', '', fmt('settlementAmountSum'), fmt('paidAmountSum'), fmt('payableBalanceSum'), fmt('duePayableAmountSum'), fmt('duePayableBalanceSum'), fmt('overduePayableAmountSum'), days]
    },
    loadData() {
      if (this.startDate && this.endDate && this.startDate > this.endDate) {
        this.$message.warning('查询时间起不能晚于查询时间止')
        return
      }
      if (!this.contractId) {
        this.tableData = []
        this.pagination.total = 0
        this.detailTotals = null
        return
      }
      this.loading = true
      const params = {
        contractId: this.contractId,
        page: this.pagination.currentPage - 1,
        size: this.pagination.pageSize
      }
      if (this.startDate) params.startDate = this.startDate
      if (this.endDate) params.endDate = this.endDate
      const sn = (this.settlementNumber || '').trim()
      if (sn) {
        params.settlementNumber = sn
      }
      api.statistics.getAccountsPayableSummaryDetail(params)
        .then(response => {
          if (response.data && response.data.success) {
            const data = response.data.data || {}
            this.tableData = data.content || []
            this.pagination.total = data.totalElements || 0
            this.detailTotals = data.totals || null
          } else {
            this.tableData = []
            this.detailTotals = null
            this.$message.error(response.data?.message || '获取应付账款明细失败')
          }
        })
        .catch(err => {
          this.tableData = []
          this.detailTotals = null
          this.$message.error(err.response?.data?.message || '获取应付账款明细失败')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-container {
  padding: 20px;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.header-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}
.title-mark {
  width: 4px;
  height: 18px;
  background: #409eff;
  margin-right: 10px;
}
.scope-tip {
  margin-bottom: 16px;
  color: #606266;
  font-size: 14px;
}
.search-area {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.search-input.date-picker {
  width: 200px;
}
.table-area {
  margin-bottom: 20px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
::v-deep .el-table th {
  background-color: #f5f7fa !important;
  color: #606266 !important;
  font-weight: 600;
}
::v-deep .el-table__footer-wrapper tbody td {
  background-color: #fafafa !important;
  font-weight: 600;
}
</style>
